var loginInit = function () {
    jQuery.validator.setDefaults({

        errorElement: "span",
        errorPlacement: function (error, element) {
            error.addClass("help-block");

            if (element.prop("type") === "checkbox") {
                error.insertAfter(element.parent());
            }
            else {
                error.insertAfter(element);
            }
        },
        highlight: function (element, errorClass, validClass) {
            $(element).parents('.form-group').addClass("has-error").removeClass("has-success");
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parents('.form-group').addClass("has-success").removeClass("has-error");
        }

    });
    $(".login-form").validate({
        rules: {
            email: {
                required: true,
                email: true,
                emaildomain: true
            },
            password: {
                required: true
            }
        },
        messages: {
        }
    });

    $(".register-form").validate({
        rules: {
            'first_name': {
                required: true,
                lettersonly: true,
                minlength: 2
            },
            'last_name': {
                required: true,
                lettersonly: true,
                minlength: 2
            },
            'email': {
                required: true,
                email: true,
                emaildomain: true
            },
            'phone_number': {
                required: true
            },
            'password': {
                required: true,
                minlength: 8
            },
            'gdpr_agreement': {
                required: true
            },
            'user_agreement': {
                required: true
            }
        },
        messages: {
            'gdpr_agreement': {
                required: "Lütfen onaylayınız"
            },
            'user_agreement': {
                required: "Lütfen onaylayınız"
            }
        }
    });


    $(".new-password-form").validate({
        rules: {
            password: {
                required: true
            },
            password_confirm: {
                required: true
            }
        },
        messages: {
        }
    });

    $(".contact-form").validate({
        rules: {
            first_name: {
                required: true,
                lettersonly: true
            },
            last_name: {
                required: true,
                lettersonly: true
            },
            phone_number: {
                required: true
            },
            department: {
                required: true
            },
            subject: {
                required: true
            },
            message: {
                required: true
            }
        }
    });

};
App.prototype.pageDetector('login-page-wrapper', loginInit);
